import { z } from 'zod';

export const periodSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  startDate: z.string().min(1, 'Start date is required'),
  endDate: z.string().min(1, 'End date is required'),
  status: z.enum(['open', 'closed']).optional(),
}).refine((data) => {
  if (!data.startDate || !data.endDate) return true;
  return new Date(data.startDate) <= new Date(data.endDate);
}, {
  message: 'End date must be after start date',
  path: ['endDate'],
});

export type PeriodFormData = z.infer<typeof periodSchema>;
